import React from 'react';
import styles from './settings-modal-content.module.scss';

export function SettingsModalContent({ children }) {
    return <div className={styles.settingsModal}>{children}</div>;
}
